export default __webpack_public_path__ + "static/thirdFloor-995a8b72c334fb79feef90aa3f66fffe.png";